export const getEnvironmentHost = ({ domain }: { domain: string }) => {
  const environment = getEnvironment()

  return `http${environment === 'local' ? '' : 's'}://${domain}${environment ? `.${environment}` : ''}.imperium.markets`
}

export const getEnvironment = () => {
  const host = window.location.host
  const [, environment] = host.match(/outback\.([^.]+)\.imperium\.markets/)
  return environment
}
